import _cloneDeep from 'lodash/cloneDeep';
import { Folders } from 'components/folders-and-labels';

/** @ngInject */
export default function foldersRouter($stateProvider) {
    const foldersState = {
        url: '/folders',
        views: {
            contentBody: {
                component: Folders.Component.selector
            }
        }
    };

    $stateProvider
        .state('main.folders-and-labels.folders', foldersState)
        .state('main.folders-and-labels.folders.folder', {
            url: '/{folderId}',
            resolve: {
                /** @ngInject */
                folder(FolderService, $stateParams) {
                    return _cloneDeep(FolderService.getFolder($stateParams.folderId));
                }
            },
            /** @ngInject */
            onEnter(folder, $state) { // eslint-disable-line consistent-return
                if (!folder) {
                    return $state.target('main.folders-and-labels.folders');
                }
            },
            component: Folders.FolderDetails.selector
        });
}



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/folders/folders.router.js